/*============================================================================
  Collection facets + sorting (Tvisva)
  Native Shopify storefront filtering (collection.filters) with AJAX via the
  Section Rendering API. Replaces the legacy jQuery/History/?constraint system,
  which modern Shopify ignores. Vanilla JS, no jQuery / History.js dependency.
==============================================================================*/
(function () {
  'use strict';

  var CONTAINER = '#CollectionMain';
  var FORM = 'form[data-collection-filters]';

  function container() { return document.querySelector(CONTAINER); }
  function sectionId() {
    var el = document.querySelector('[data-section-id]');
    return el ? el.getAttribute('data-section-id') : null;
  }
  function debounce(fn, wait) {
    var t;
    return function () {
      var ctx = this, args = arguments;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  function setLoading(on) {
    var c = container();
    if (!c) return;
    c.classList.toggle('engo-filtering', !!on);
  }

  /* Build a collection URL (no section_id) from a filter form's current state */
  function urlFromForm(form) {
    var data = new FormData(form);
    var params = new URLSearchParams();
    data.forEach(function (value, key) {
      if (value !== '' && value != null) params.append(key, value);
    });
    var action = form.getAttribute('action') || location.pathname;
    var qs = params.toString();
    return action + (qs ? '?' + qs : '');
  }

  function render(url, fromPopState) {
    var id = sectionId();
    var c = container();
    if (!id || !c) { window.location.href = url; return; } // graceful fallback

    var abs = new URL(url, location.origin);
    abs.searchParams.delete('page'); // always show first page after a filter change

    var fetchUrl = new URL(abs.href);
    fetchUrl.searchParams.set('section_id', id);

    setLoading(true);
    fetch(fetchUrl.href, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector(CONTAINER);
        var live = container();
        if (fresh && live) {
          live.innerHTML = fresh.innerHTML;
        }
        if (!fromPopState) {
          history.pushState({ engoFilter: true }, '', abs.pathname + abs.search);
        }
        setLoading(false);
        reinit();
        // keep the mobile filter drawer open if it was open
        scrollIntoViewIfNeeded();
      })
      .catch(function () {
        setLoading(false);
        // fall back to a full navigation on error
        window.location.href = abs.pathname + abs.search;
      });
  }

  function scrollIntoViewIfNeeded() {
    // no-op placeholder; avoid jarring jumps on filter change
  }

  /* Re-run inits for swapped-in markup (guarded so missing libs never throw) */
  function reinit() {
    try { if (typeof window.quickView === 'function') window.quickView(); } catch (e) {}
    try {
      if (window.ajaxCart && typeof window.ajaxCart.init === 'function') {
        window.ajaxCart.init({
          cartContainer: '.enj-minicart-ajax',
          addToCartSelector: '.enj-add-to-cart-btn',
          cartCountSelector: '.enj-cartcount',
          cartCostSelector: '.enj-cartcost',
          moneyFormat: window.money_format || '$'
        });
      }
    } catch (e) {}
    try { if (window.lazySizes && typeof lazySizes.init === 'function') lazySizes.init(); } catch (e) {}
    document.dispatchEvent(new CustomEvent('collection:reloaded'));
  }

  var debouncedApply = debounce(function (form) { render(urlFromForm(form)); }, 500);

  function onChange(e) {
    var form = e.target.closest ? e.target.closest(FORM) : null;
    if (!form) return;
    if (e.target.matches('input[type="number"], .engo-price-input')) {
      debouncedApply(form);
    } else {
      render(urlFromForm(form));
    }
  }

  function onSubmit(e) {
    var form = e.target.closest ? e.target.closest(FORM) : null;
    if (!form) return;
    e.preventDefault();
    render(urlFromForm(form));
  }

  function onClick(e) {
    // active-filter chips + clear-all
    var rm = e.target.closest ? e.target.closest('a[data-filter-url]') : null;
    if (rm) { e.preventDefault(); render(rm.getAttribute('data-filter-url')); return; }

    // sort dropdown links (href is the sort_by value, e.g. "price-ascending")
    var sort = e.target.closest ? e.target.closest('.collection-sorting a') : null;
    if (sort) {
      e.preventDefault();
      var val = sort.getAttribute('href');
      var u = new URL(location.href);
      u.searchParams.set('sort_by', val);
      u.searchParams.delete('page');
      // reflect label + active state immediately
      var label = sort.closest('.dropdown') && sort.closest('.dropdown').querySelector('.dropdown-label');
      if (label) label.textContent = sort.textContent.trim();
      var list = sort.closest('.dropdown-content');
      if (list) {
        list.querySelectorAll('li').forEach(function (li) { li.classList.remove('active'); });
        if (sort.parentElement) sort.parentElement.classList.add('active');
        list.classList.remove('active');
      }
      render(u.pathname + u.search);
    }
  }

  function init() {
    if (!container()) return;
    document.addEventListener('change', onChange);
    document.addEventListener('submit', onSubmit);
    document.addEventListener('click', onClick);
    window.addEventListener('popstate', function () { render(location.href, true); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
